 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"6b1343964a07959390114255fd25a93ba981ec04","2":"8c787455f67ef7209a14176bac794d634ceb1844","3":"6dd4ff1fd56e5d3a78c9b2df567608ea0f635c1c","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","6":"0621d8b58401fbbb4648cde9e41b980a21cfd385","7":"45b8fa8f769eeaf30dce263ad16a43012959eb36","8":"8cb571fb712555b5543ea31367cbc028f1f27102","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"7490bd49aa53622910970b252a264e0dd9ced745","15":"f9beb1971ea41977cd67fb00c0ea9bc6705181bd","16":"fd113b4cd44afc312952b5152606df4c80fa1a9f","20":"component---src-pages-404-jsx","21":"component---src-pages-about-jsx","22":"component---src-pages-accessibility-index-jsx","23":"component---src-pages-accessibility-statement-jsx","24":"component---src-pages-accolades-jsx","25":"component---src-pages-alternative-index-jsx","26":"component---src-pages-black-friday-dear-manager-jsx","27":"component---src-pages-black-friday-index-jsx","28":"component---src-pages-calculator-jsx","29":"component---src-pages-case-studies-jsx","30":"component---src-pages-color-contrast-jsx","31":"component---src-pages-create-workspace-jsx","32":"component---src-pages-css-3-d-transform-examples-index-jsx","33":"component---src-pages-css-specificity-calculator-jsx","34":"component---src-pages-dear-manager-jsx","35":"component---src-pages-disclaimer-jsx","36":"component---src-pages-docs-changelog-jsx","37":"component---src-pages-docs-faq-jsx","38":"component---src-pages-docs-index-jsx","39":"component---src-pages-download-jsx","40":"component---src-pages-experimental-web-platform-features-jsx","41":"component---src-pages-exported-panes-jsx","42":"component---src-pages-form-inspector-index-jsx","43":"component---src-pages-github-students-jsx","44":"component---src-pages-index-jsx","45":"component---src-pages-integrations-index-jsx","46":"component---src-pages-integrations-jetbrains-webstorm-jsx","47":"component---src-pages-integrations-markerio-jsx","48":"component---src-pages-integrations-toybox-systems-jsx","49":"component---src-pages-integrations-tumult-hype-jsx","50":"component---src-pages-integrations-tumult-whisk-jsx","51":"component---src-pages-legal-jsx","52":"component---src-pages-newsletter-jsx","53":"component---src-pages-og-screenshot-jsx","54":"component---src-pages-opener-jsx","55":"component---src-pages-portal-index-jsx","56":"component---src-pages-pricing-jsx","57":"component---src-pages-privacy-jsx","58":"component---src-pages-product-tour-jsx","59":"component---src-pages-quality-assurance-index-jsx","60":"component---src-pages-resources-jsx","61":"component---src-pages-responsive-design-glossary-jsx","62":"component---src-pages-responsive-website-test-jsx","63":"component---src-pages-screenshot-comparison-jsx","64":"component---src-pages-site-quality-index-jsx","65":"component---src-pages-social-media-previews-index-jsx","66":"component---src-pages-special-offers-jsx","67":"component---src-pages-support-index-jsx","68":"component---src-pages-syntax-jsx","69":"component---src-pages-tailwindcss-jsx","70":"component---src-pages-testimonials-jsx","71":"component---src-pages-thanks-jsx","72":"component---src-pages-visualize-browser-sizes-jsx","73":"component---src-templates-blog-list-jsx","74":"component---src-templates-doc-jsx","75":"component---src-templates-post-jsx","76":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"996b5d00786c6d65f29e","2":"a77dd4cfa98cb3205825","3":"690af6d0261fe6de3d9f","4":"8a50615bc752d1273f48","5":"cf6ef8c9e769145c0a93","6":"fe13ae4bdf05274b13e9","7":"e4718e9f39808fd355db","8":"b321f8e953504f41f69f","9":"ae0f1b8b7dc023d4685a","10":"95e5918f894d411d8fce","11":"99ced224b35a92bf44dd","12":"7926e00e6ed7fa314542","13":"4d2271910e950a98f200","14":"26d9e1055df2c4e3dcea","15":"85ef9c034d88cff74f4c","16":"7500cc163d355e46fc4d","18":"cbc501a854151cc5b152","20":"f058dbf17cc0200988ce","21":"84144ed4aa554e513fc7","22":"1131c49292014a1a520b","23":"b1355d6b5bf33e313886","24":"5d3955089e735afa025b","25":"1ffcdf2f465dc2a46a93","26":"7969a313e38b6729461e","27":"22a6c99e4e1a984d661b","28":"675a12bdbe9e698d8eb8","29":"5d29b96cf36e906ef877","30":"0ea5f399a7d116c27b1f","31":"2e00556f28bda17f034e","32":"d4dfc89214409eab4fd6","33":"409196be383e43f2c88f","34":"de559709992e72587690","35":"3e38991ddccecd8f76a5","36":"055c6e6bd924d492de83","37":"ad8f67a68afa66cfd96d","38":"3d48d90fc82d1d449d1c","39":"74bf27ebb775d3cf6909","40":"a9125dff3ab5aa183553","41":"323f535db2e1db6f5d44","42":"1661dc47273d582c8be3","43":"8f51579a2f4e453d3902","44":"39f25a309063d49f3cf3","45":"1ab797b5fa427d2fef05","46":"e6b9200c7e387d17a65d","47":"5f1621104aa7b34e2c0c","48":"bd48c57ddde907ec72eb","49":"129303f521aaaccd29a9","50":"ea02f110591b0ad3821d","51":"75aaa58ec7cba616b2af","52":"cb34bcf9ace459e918a8","53":"d1f060d3a4f5f6a93fd2","54":"fd170182a619dbb50659","55":"e1be2676cfca064e3034","56":"0592f3c27c249fbdad41","57":"51ea951ed8eb20614b33","58":"fa858c664d1697f780ec","59":"7bb154fcf04ecd4ea65f","60":"905c1212c6bd3b00bebe","61":"a33709fd643cd1943129","62":"6637b1dc4d9128827919","63":"bc92a3da5320a943a2a1","64":"13f1b9a8b7949da79bb0","65":"8de5331e8b6de98c0408","66":"522f93cc334df57f30d6","67":"91783342999ae72492de","68":"ed6fb6d92319536deaf5","69":"ff458722495585b41465","70":"763de7faca0303b59e57","71":"c8e66a5ee5bd3e351962","72":"a98f4cfd878fc001e4a5","73":"c3bd220142f95f44b569","74":"e3aee02f6dfb241fc344","75":"ddc9e727b4b1dfbed987","76":"a42a3280f26b4f24b896","78":"ed3d3d25196b33974f4f","79":"d10efb18cc26e0924de0","80":"047a3609cca719a287da","81":"518b91e0bafc4dc45d5e","82":"14f0265559a66350a6e3","83":"057cedc8928c2997d509","84":"5cb189bf8981bf5dd8ff","85":"519d6d7093f580099082","86":"f93be4c3a9c56c4952af","87":"de60a41850573be0b35c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"6b1343964a07959390114255fd25a93ba981ec04","2":"8c787455f67ef7209a14176bac794d634ceb1844","3":"6dd4ff1fd56e5d3a78c9b2df567608ea0f635c1c","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","6":"0621d8b58401fbbb4648cde9e41b980a21cfd385","7":"45b8fa8f769eeaf30dce263ad16a43012959eb36","8":"8cb571fb712555b5543ea31367cbc028f1f27102","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"7490bd49aa53622910970b252a264e0dd9ced745","15":"f9beb1971ea41977cd67fb00c0ea9bc6705181bd","16":"fd113b4cd44afc312952b5152606df4c80fa1a9f","20":"component---src-pages-404-jsx","21":"component---src-pages-about-jsx","22":"component---src-pages-accessibility-index-jsx","23":"component---src-pages-accessibility-statement-jsx","24":"component---src-pages-accolades-jsx","25":"component---src-pages-alternative-index-jsx","26":"component---src-pages-black-friday-dear-manager-jsx","27":"component---src-pages-black-friday-index-jsx","28":"component---src-pages-calculator-jsx","29":"component---src-pages-case-studies-jsx","30":"component---src-pages-color-contrast-jsx","31":"component---src-pages-create-workspace-jsx","32":"component---src-pages-css-3-d-transform-examples-index-jsx","33":"component---src-pages-css-specificity-calculator-jsx","34":"component---src-pages-dear-manager-jsx","35":"component---src-pages-disclaimer-jsx","36":"component---src-pages-docs-changelog-jsx","37":"component---src-pages-docs-faq-jsx","38":"component---src-pages-docs-index-jsx","39":"component---src-pages-download-jsx","40":"component---src-pages-experimental-web-platform-features-jsx","41":"component---src-pages-exported-panes-jsx","42":"component---src-pages-form-inspector-index-jsx","43":"component---src-pages-github-students-jsx","44":"component---src-pages-index-jsx","45":"component---src-pages-integrations-index-jsx","46":"component---src-pages-integrations-jetbrains-webstorm-jsx","47":"component---src-pages-integrations-markerio-jsx","48":"component---src-pages-integrations-toybox-systems-jsx","49":"component---src-pages-integrations-tumult-hype-jsx","50":"component---src-pages-integrations-tumult-whisk-jsx","51":"component---src-pages-legal-jsx","52":"component---src-pages-newsletter-jsx","53":"component---src-pages-og-screenshot-jsx","54":"component---src-pages-opener-jsx","55":"component---src-pages-portal-index-jsx","56":"component---src-pages-pricing-jsx","57":"component---src-pages-privacy-jsx","58":"component---src-pages-product-tour-jsx","59":"component---src-pages-quality-assurance-index-jsx","60":"component---src-pages-resources-jsx","61":"component---src-pages-responsive-design-glossary-jsx","62":"component---src-pages-responsive-website-test-jsx","63":"component---src-pages-screenshot-comparison-jsx","64":"component---src-pages-site-quality-index-jsx","65":"component---src-pages-social-media-previews-index-jsx","66":"component---src-pages-special-offers-jsx","67":"component---src-pages-support-index-jsx","68":"component---src-pages-syntax-jsx","69":"component---src-pages-tailwindcss-jsx","70":"component---src-pages-testimonials-jsx","71":"component---src-pages-thanks-jsx","72":"component---src-pages-visualize-browser-sizes-jsx","73":"component---src-templates-blog-list-jsx","74":"component---src-templates-doc-jsx","75":"component---src-templates-post-jsx","76":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "." + {"0":"00b44bbf421e0b6fd1cb","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c","87":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
